import LocalizedStrings from "react-localization";

const languages = ["sl"];

const strings = new LocalizedStrings({
  sl: {
    appName: "Prijavni sistem 404",
    takeMeHome: "Domov",
    cookies: "Piškotki",
    iAgree: "strinjam se",
    and: "in",

    // activity
    couldNotLoadActivityData: "Napaka pri nalaganju podatkov za prijavo.",
    loadingData: "Nalaganje podatkov.",
    signUpDisabled: "Prijave onemogočene",
    signUpDisabledDescription:
      "Prijave za to aktivnost trenutno niso omogočene.",
    signUpNotYetActive: "Prijave še niso mogoče",
    signUpNotYetActiveDescription: "Prijave se odprejo",
    signUpNotActiveAnymore: "Prijave zaključene",
    signUpNotActiveAnymoreDescription:
      "Prijave na to aktivnost so žal že zaključene.",
    signUpFor: "Prijave na",
    paymentMethod: "Način plačila",
    price: "cena",
    youHaveToChooseYourPaymentMethod: "Izbrati morate način plačila.",
    cardPayment: "Plačilo s kartico",
    free: "brezplačno",
    trr: "Bančno nakazilo",
    submitApplication: "oddaj prijavo",
    numberOfInstallments: "Število obrokov",
    iAgreeWith: "Strinjam se s",
    fieldIsRequired: (fieldName) => `Polje '${fieldName}' je obvezno.`,
    fieldIsRequiredForDate: (fieldName, date) =>
      `Polje '${fieldName}' je obvezno (${date}).`,
    fieldEmailRequired: "Vnesti morate pravilen email naslov",
    iAgreeWithPrivacyPolicy: "politiko zasebnosti",
    iAgreeWithTerms: "pogoji poslovanja",
    youHaveToAgreeWithPrivacyPolicy:
      "Strinjati se morate s politiko zasebnosti in pogoji poslovanja.",
    youHaveToPassRecaptcha: "Pokazati morate, da niste robot.",
    submitError: "Napaka pri oddajanju prijave.",
    submitErrorDescription: "Prosimo poskusite kasneje.",
    submitErrorText: "Poskusi znova",
    submitSuccess: "Prijava oddana",
    submitSuccessDescription:
      "Poslali smo vam potrditveno e-pošto na vpisani naslov.",
    submitSuccessText: "Oddaj novo prijavo",
    signUpRemoved: "Prijava odstranjena",
    signUpRemovedDescription:
      "Iskana prijavnica je bila označena kot odjavljena.",
    submitSuccessAdditionalButtonsTitle: "Preveri še druge aktivnosti:",

    // coupons
    couponCode: "Koda za popust",
    couponHaveCode: "Imate kodo za popust?",
    couponAppliedHelper: "Koda je uveljavljena, popust je upoštevan v ceni.",
    couponApply: "Uveljavi",
    couponRemove: "Odstrani",
    couponApplied: (code) => `Kupon ${code}`,
    couponDiscount: (amount) => `-${amount}`,
    couponFreeDescription:
      "S kupon kodo je prijava brezplačna, plačilo ni potrebno.",
    // Single message for every coupon failure, same as the API returns.
    couponCheckError: "Koda ni veljavna.",
    submitErrorInline: "Prijave ni bilo mogoče oddati:",

    // booking (rezervacije)
    bookingFor: "Rezervacija termina",
    couldNotLoadBookingData: "Napaka pri nalaganju podatkov za rezervacijo.",
    chooseDates: "Izberite termine",
    chooseDatesHelp:
      "Označite želene termine in za vsakega izpolnite podatke o skupini.",
    week: "Teden",
    groupLabel: (n) => `${n}. oddelek`,
    noDatesAvailable: "Trenutno ni razpisanih terminov.",
    slotsRemaining: (n) => {
      const r = n % 100;
      if (r === 1) return `še ${n} prosto mesto`;
      if (r === 2) return `še ${n} prosti mesti`;
      if (r === 3 || r === 4) return `še ${n} prosta mesta`;
      return `še ${n} prostih mest`;
    },
    dateFull: "Zasedeno",
    yourDetails: "Vaši podatki",
    youHaveToSelectDate: "Izbrati morate vsaj en termin.",
    submitBooking: "oddaj rezervacijo",
    reviewTitle: "Preverite rezervacijo",
    reviewIntro: "Prosimo, preverite podatke pred oddajo rezervacije.",
    reviewBack: "Nazaj",
    reviewConfirm: "Potrdi in oddaj",
    bookingSubmitSuccess: "Rezervacija oddana",
    bookingSubmitSuccessDescription:
      "Vaša rezervacija je bila uspešno oddana. Hvala!",
    bookingSubmitSuccessText: "Oddaj novo rezervacijo",
    bookingDateFull:
      "Izbrani termin je medtem postal zaseden. Prosimo, izberite drug termin.",

    // date picker
    cancel: "Prekliči",
    clear: "Pobriši",
    ok: "Ok",
    today: "Danes",

    // errors
    errorUnknown: "Neznana napaka.",
    404: "Iskana stran za prijave ne obstaja.",

    // payments
    loadingPaymentsError: "Napaka pri nalaganju plačil",
    loadingPaymentsErrorDescription: "Prosimo poskusite pozneje",
    paymentFor: "Plačilo za",
    forPerson: "za osebo",
    paid: "Plačano",
    pay: "Plačaj",
    payInAdvance: "Plačaj vnaprej",
    companyName: "404: Mladinski tehnološko - razvojni center",
    companyAddress: "Mencingerjeva ulica 7",
    companyCity: "1000 Ljubljana",
  },
});

strings.setLanguage("si");

export { languages };
export default strings;
